import { pickersMonthClasses } from "@mui/x-date-pickers";
import alpha from "color-alpha";
import { typography } from "../typography/typography.js";
import "../typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../typography/utils/typographyVariants/typographyVariants.js";
const MuiPickersMonth = {
  styleOverrides: {
    monthButton: ({ theme }) => ({
      margin: "10px 12px",
      ...typography["Lato Body 1"],
      "&:hover, &:active": {
        color: theme.palette.grey["900"],
        backgroundColor: theme.palette.primary["75"]
      },
      '&[aria-current="date"]': {
        border: `1px solid ${theme.palette.primary["800"]}`,
        backgroundColor: theme.palette.primary["10"],
        color: theme.palette.primary["900"],
        "&:hover": {
          backgroundColor: alpha(theme.palette.primary["800"], 0.08)
        }
      },
      [`&.${pickersMonthClasses.selected}`]: {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary["800"],
        ...typography["Lato Emphasized 1"],
        "&:hover, &:active": {
          color: theme.palette.common.white,
          backgroundColor: theme.palette.primary["900"]
        },
        "&:focus, &:focus-visible": {
          backgroundColor: theme.palette.primary["900"],
          boxShadow: `0px 0px 0px 1px ${theme.palette.common.white}, 0px 0px 0px 3px ${theme.palette.grey["800"]};`
        }
      },
      [`&.${pickersMonthClasses.disabled}`]: {
        color: alpha(theme.palette.grey["900"], 0.38)
      }
    })
  }
};
export {
  MuiPickersMonth
};
